import { useTranslate } from "@made-people/grease-translations";
import { Ruler } from "../../../assets/icons/Ruler";
import { useSizeGuide } from "./use-size-guide";
import { openSizeGuide } from "./size-guide";
import { useMaybeProductBase, ProductBase } from "@made-people/grease-product";

const inferProductTypeFromProduct = (
  productBase: ProductBase | undefined,
): string | undefined => {
  if (!productBase) return undefined;

  // Try product_type attribute first
  const productTypeAttr = productBase.attributes.find(
    (attr) => attr.attributeKey === "product_type",
  );
  if (productTypeAttr?.value && typeof productTypeAttr.value === "string") {
    return productTypeAttr.value;
  }

  // Fallback: check category name
  const categoryName = productBase.categories[0]?.name;
  if (categoryName) {
    const normalizedCategory = categoryName.toLowerCase();
    if (
      normalizedCategory.includes("panty") ||
      normalizedCategory.includes("tanga") ||
      normalizedCategory.includes("trosor")
    ) {
      return "panty";
    }
    if (
      normalizedCategory.includes("bra") ||
      normalizedCategory.includes("bh")
    ) {
      return "bra";
    }
    if (
      normalizedCategory.includes("swim") ||
      normalizedCategory.includes("bikini")
    ) {
      return "swimwear";
    }
    if (
      normalizedCategory.includes("stocking") ||
      normalizedCategory.includes("strump")
    ) {
      return "stockings";
    }
    if (
      normalizedCategory.includes("camisole") ||
      normalizedCategory.includes("top") ||
      normalizedCategory.includes("linne")
    ) {
      return "camisoles";
    }
  }

  // Fallback: check product slug
  const slug = productBase.slug.toLowerCase();
  if (
    slug.includes("panty") ||
    slug.includes("tanga") ||
    slug.includes("trosor")
  ) {
    return "panty";
  }
  if (slug.includes("bra") || slug.includes("bh")) {
    return "bra";
  }
  if (slug.includes("swim") || slug.includes("bikini")) {
    return "swimwear";
  }
  if (slug.includes("stocking") || slug.includes("strump")) {
    return "stockings";
  }
  if (
    slug.includes("camisole") ||
    slug.includes("top") ||
    slug.includes("linne")
  ) {
    return "camisoles";
  }

  return undefined;
};

interface SizeGuideTriggerProps {
  /**
   * Optional product type to use when not inside a ProductProvider.
   * If not provided and not in ProductProvider, defaults to "bra".
   */
  productType?: string;
  /**
   * Optional custom className for the button
   */
  className?: string;
}

export const SizeGuideTrigger = ({
  productType: propProductType,
  className,
}: SizeGuideTriggerProps = {}) => {
  const translate = useTranslate();
  const sizeGuide = useSizeGuide();
  const productBase = useMaybeProductBase();

  // Use prop productType if provided, otherwise try to infer from product
  const productType =
    propProductType ?? inferProductTypeFromProduct(productBase);

  if (!sizeGuide) {
    return null;
  }

  const handleClick = () => {
    openSizeGuide(productType);
  };

  return (
    <button
      className={`flex items-center gap-3 text-body-md  w-fit ${className ?? ""}`}
      onClick={handleClick}
    >
      <Ruler className="w-10 h-10" />
      <span className="underline underline-offset-2">
        {translate("Size_Guide_Button")}
      </span>
    </button>
  );
};
